import React, { memo, useEffect } from 'react'
import PersonalInformation from './personal-information/PersonalInformation'
import { AppDispatch } from '../../../stores/store'
import { useDispatch, useSelector } from 'react-redux'
import { currentStepSelector, moveToStep } from '../../../stores/slices/customer-registration-slice'
import IdentityInformation from './identity-information/IdentityInformation'
import FinancialInformation from './financial-information/FinancialInformation'
import EmploymentInformation from './employment-information/EmploymentInformation'
import { buySolarProductSelector } from '../../../stores/slices/buy-solar-product-slice'
import { useLocation, useNavigate } from 'react-router-dom'
import { ApplicationRoutes } from '../../../routes'

type Props = {}

const CustomerRegistration: React.FC<Props> = memo((props: Props) => {
    const currentStep = useSelector(currentStepSelector)

    const buySolarProduct = useSelector(buySolarProductSelector);

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch<AppDispatch>()


    useEffect(() => {
        moveToStep(1)
        if (buySolarProduct.productDetailsId == null || buySolarProduct.durationOfPaymentsInMonths == null && location.state == null) {
            // Check if there is a previous entry in the history stack
            // if (window.history.length > 1 ) {
            //     navigate(-1);
            // } else {
            //     navigate('/');
            // }
        }
    }, [buySolarProduct, navigate])

    const navigateFinish = () => {
        if (location.state) {
            navigate(location.state.orderUrl);
        } else {
            navigate(`${ApplicationRoutes.CUSTOMER_NEXT_STEP}`)
        }
    }

    return (
        <>
            <div style={
                {
                    display: currentStep === 1 ? 'block' : 'none'
                }
            }>
                <PersonalInformation 
                    stepNumber={1}
                    onBack={(index: number) => {
                        if (index == 0) navigate(-1);
                        else dispatch(moveToStep(index))
                    }}
                    onNext={(index: number) => dispatch(moveToStep(index))}
                />
            </div>
            <div style={
                {
                    display: currentStep === 2 ? 'block' : 'none'
                }
            }>
                <EmploymentInformation 
                    stepNumber={2}
                    onBack={(index: number) => dispatch(moveToStep(index))}
                    onNext={(index: number) => dispatch(moveToStep(index))}
                />
            </div>
            <div style={
                {
                    display: currentStep === 3 ? 'block' : 'none'
                }
            }>
                <IdentityInformation 
                    stepNumber={3}
                    onBack={(index: number) => dispatch(moveToStep(index))}
                    onNext={(index: number) => dispatch(moveToStep(index))}
                />
            </div>
            <div style={
                {
                    display: currentStep === 4 ? 'block' : 'none'
                }
            }>
                <FinancialInformation 
                    stepNumber={4}
                    onBack={(index: number) => dispatch(moveToStep(index))}
                    onNext={(index: number) => navigateFinish()}
                />
            </div>
        </>
    )
})

export default CustomerRegistration